import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import _imports_0 from '@/assets/logo.png';
const _hoisted_1 = {
  key: 0,
  class: "system-title"
};
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  class: "sidebar-logo"
};
const _hoisted_3 = {
  key: 1,
  class: "system-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_aside_item = _resolveComponent("aside-item");
  const _component_el_menu = _resolveComponent("el-menu");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  return _openBlock(), _createElementBlock("div", null, [!_ctx.isCollapse ? (_openBlock(), _createElementBlock("div", _hoisted_1, [$data.logo ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString($data.settingsTitle), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_3, "Cost")), _cache[0] || (_cache[0] = _createElementVNode("div", null, null, -1)), _createVNode(_component_el_scrollbar, null, {
    default: _withCtx(() => [_createVNode(_component_el_menu, {
      "unique-opened": true,
      "default-openeds": $data.defaultOpeneds,
      "default-active": $data.defaultActive,
      collapse: _ctx.isCollapse,
      class: "left-aside",
      onSelect: $options.handleSelect,
      onOpen: $options.handleOpen,
      onClose: $options.handleClose,
      "background-color": "rgb(48, 65, 86)",
      "text-color": "#fff"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu, idx) => {
        return _openBlock(), _createBlock(_component_aside_item, {
          key: idx,
          item: menu
        }, null, 8, ["item"]);
      }), 128))]),
      _: 1
    }, 8, ["default-openeds", "default-active", "collapse", "onSelect", "onOpen", "onClose"])]),
    _: 1
  })]);
}